import { memo } from 'react'

import { useLiveChatSDK } from '@inno-sdk/livechat-sdk'
import { AppId } from '@inno-tools/container-bridge'
import { FullPageAppTemplate } from 'modules/app-registry/templates'
import { useNavigate } from 'react-router-dom'
import { useHistory, useUserContext } from 'shared/hooks'

import { useAvailableApps } from '../hooks/useAvailableApps'

export const AfterSalesApp = memo(
  () => {
    const navigate = useNavigate()
    const { location } = window
    const { user } = useUserContext()
    const { livechat } = useLiveChatSDK()
    const { apps } = useAvailableApps()
    const history = useHistory()

    return (
      <FullPageAppTemplate
        appId={AppId.AFTER_SALES}
        scope='after_sales'
        envKey={apps[AppId.AFTER_SALES].runtimeEnvKey}
        entryPath='./AfterSalesApp'
        url={process.env.REACT_APP_AFTER_SALES_APP_DEV_PATH}
        appName={apps[AppId.AFTER_SALES].name}
        appProps={{
          user,
          defaultHistory: history,
          livechat: livechat,
          initialPath: location.pathname,
          onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
            const { pathname } = location
            if (pathname !== nextPathname) {
              navigate(nextPathname)
            }
          },
          isWidget: false
        }}
      />
    )
  },
  // when there are no props, this is OK to use. without this comparison function, we will have higher memory usage
  () => true
)
